<template>
  <transition name="slide-up" v-if="opened">
    <div class="counter">
      <div class="container">
        <div class="counter__wrap">
          <div class="counter__count">
            <ProgressCircle :percent="percent" :stroke-color="strokeColor" />
            <div class="counter__data">
              <div class="counter__time">{{ counter }} c</div>
              <div class="counter__helper">осталось</div>
            </div>
          </div>
          <div class="counter__content">
            <div class="counter__title">Оставьте заявку сейчас и мы подарим настройку контекстной рекламы!</div>
            <div class="counter__caption">Заявка ни к чему вас не обязывает, зато гарантирует подарок в случае, если вы решите работать с нами.</div>
          </div>
          <div class="counter__action">
            <router-link to="/get-discount" class="button">Получить подарок!</router-link>
            <div class="menu__close counter__close" @click="close"><i class="mdi mdi-window-close"></i></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import ProgressCircle from '@/components/Progress.vue';
const name = 'Converter'

function data() {
  return {
    time: 60,
    counter: 60,
    opened: false,
    timeoutToOpen: 15000, // 15s
    timeoutInstance: false
  }
}

const watch = {
  '$route': function(val) {
    if (val.path == '/get-discount') {
      this.opened = false
      clearTimeout(this.timeoutInstance)
    }
  },
  opened(val) {
    if(val) {
      document.body.classList.add("body--counter")
    } else {
      document.body.classList.remove("body--counter")
    }
  }
}

const computed = {
  percent() {
    return this.counter / this.time
  },
  strokeColor() {
    const inst = this

    if (inst.counter >= (inst.time / 2)) {
      return '#4dcd3b'
    } else if (inst.counter >= (inst.time / 4) && inst.counter <= inst.time / 2) {
      return '#ffc107'
    } else {
      return '#d72314de'
    }
  }
}

function created() {
  const inst = this

  if (inst.$route.path == '/get-discount' || inst.$route.path == '/calc' || inst.$route.path == '/brief') {
    return
  }
    let startValue = localStorage.getItem('counter') || inst.time

    if (startValue > 0 && startValue < inst.time) {
      inst.counter = startValue
      inst.startCount()
    } else if (startValue > 0) {
      inst.wait()
    }
}

function wait() {
  const inst = this

  setTimeout(() => {
    inst.startCount()
  }, inst.timeoutToOpen)
}

function startCount() {
  const inst = this
   if (inst.$route.path == '/get-discount' || inst.$route.path == '/calc' || inst.$route.path == '/brief') {
    inst.wait()
  } else {
    inst.opened = true
    inst.countStep()
  }
}

function countStep() {
  const inst = this

  inst.timeoutInstance = setTimeout(() => {
    inst.counter--
    localStorage.setItem('counter', inst.counter)

    if (inst.counter == 0) {
      inst.opened = false
      localStorage.setItem('counterShown', 1)
    } else {
      inst.countStep()
    }
  }, 1000)
}

function close() {
  this.opened = false
}


export default {
  name,
  data,
  watch,
  computed,
  created,
  methods: {
    wait,
    startCount,
    countStep,
    close
  },
  components: {
    ProgressCircle
  }
}

</script>
